import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { MustMatch } from 'src/functions/custom-validators';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-recovery-alianza',
  templateUrl: './recovery-alianza.component.html',
  styleUrls: ['./recovery-alianza.component.scss'],
})
export class RecoveryAlianzaComponent implements OnInit {
  public valueRadio: string;
  isValidEmail: boolean;
  formRecovery: FormGroup;
  truncEmail: string;
  show: boolean = false;
  token: string;
  domain: string;
  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    public ngxSmartModalService: NgxSmartModalService,
    private fb: FormBuilder,
    private auth: AuthService
  ) {
    this.valueRadio = '1';
    this.isValidEmail = false;
  }

  loadFormEmail() {
    this.formRecovery = this.fb.group(
      {
        password1: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
            ),
          ],
        ],
        password2: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
            ),
          ],
        ],
      },
      {
        validator: MustMatch('password1', 'password2'),
      }
    );
  }
  loadFormPassword() {
    this.formRecovery = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$'
          ),
        ],
      ],
      nameComercial: ['', []],
    });
  }

  ngOnInit(): void {
    this._route.paramMap.subscribe((params) => {
      if (params.get('renovate')) {
        this.valueRadio = '3';
        this.token = params.get('renovate');
        this.loadFormEmail();
      } else {
        this.loadFormPassword();
      }
    });
  }
  get f() {
    return this.formRecovery.controls;
  }

  submit() {
    if (this.formRecovery.valid) {
      if (this.valueRadio == '1') {
        this.isValidEmail = true;
        this.truncEmail = this.f.email.value;
        this.domain = '@' + this.truncEmail.split('@')[1];

        this.auth
          .recoveryPassword({ email: this.f.email.value }, 'request')
          .subscribe(
            (resp) => {
              console.log(resp);
            },
            (error) => {
              console.log(error);
            }
          );
      }
      if (this.valueRadio == '3') {
        this.auth
          .recoveryPassword(
            {
              token: this.token,
              password: this.f.password1.value,
              passwordConfirmation: this.f.password2.value,
            },
            'password'
          )
          .subscribe(
            (resp) => {
              this.openModal();
            },
            (error) => {
              console.log(error);
            }
          );
      }
    }
  }
  goToLogin() {
    this.router.navigate(['login-alianza']);
  }
  openModal() {
    this.ngxSmartModalService.getModal('renovated').open();
  }

  closeModal() {
    this.ngxSmartModalService.getModal('renovated').close();
    this.goToLogin();
  }

  switchPass() {
    this.show = !this.show;
  }
}
